var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTk = function SvgTk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M19.304 5.74a8.008 8.008 0 0 0-.156 1.617 7.855 7.855 0 0 0 4.591 7.138c.17-.805.261-1.64.261-2.495 0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12c4.11 0 7.737-2.067 9.9-5.217H6.783v-1.566h16.026c.164-.339.313-.687.445-1.043H6.783L19.304 5.739Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m8.815 6.261.259.797h.838l-.678.493.26.797-.679-.492-.678.492.259-.797-.678-.493h.838l.259-.797ZM5.411 12l.324.996h1.048l-.848.616.324.997-.848-.616-.847.616.324-.997-.848-.616h1.048L5.41 12ZM5.411 3.652l.324.997h1.048l-.848.616.324.996-.848-.616-.847.616.324-.996-.848-.616h1.048l.323-.997ZM2.802 8.348l.324.996h1.048l-.848.616.324.996-.848-.616-.848.616.324-.996-.847-.616h1.047l.324-.996Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTk;